<template>
    <div class="m-cont">
        <div class="nav-sale">
            <div class="con-sal">
                <span>
                    <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
                    <a href="#" class="btn btn-outline-info btn-sm" @click="addAccount">Add account</a>
                </span>
                GESTIONE CREDENZIALI
            </div>
        </div>    
        
        <div class="tab-cont" id="style-3">
            <table class="table" >
                <thead class="thead-dark">
                    <tr>
                        <th class="text">USERNAME</th>
                        <th class="text">PASSWORD</th>
                        <th class="text permessi">PERMESSI</th>
                         <th class="text">ELIMINA ACCOUNT</th>
                    </tr>
                    </thead>
                    <tbody >
                        <tr v-for="(utente,i) in utenti" :key="utente.id">
                            <td class="text" ><input type="text"  v-model="utente.nome"/></td>
                            <td class="text" ><input type="password"  v-model="utente.password"/></td>
                            <td class="text" >
                                <Multiselect
                                    v-model="utente.permessi"
                                    :options="permessi"
                                     mode="tags"
                                    :close-on-select="false"
                                />
                            </td>
                            <td>
                                <a href="#" class="btn btn-outline-success btn-large" @click="action(i,utente.id,utente.nome,utente.password,utente.permessi,true)">Salva</a>
                                <a href="#" class="btn btn-outline-warning btn-large" @click="action(i,utente.id,utente.nome,utente.password,utente.permessi)">Elimina</a>
                            </td>
                            
                        </tr>
                    </tbody>
            </table>
        </div>
        
    </div>
</template>

<script>
// @ is an alias to /src
import Multiselect from '@vueform/multiselect'
import { store } from '../store/store.js'
export default {
    components: {
      Multiselect,
    },
  name: 'GestionaleCredenziali',
  data: function () {
            return {
                permessi:[],
                value: [],
                utenti:[],
                store

            }
   },
  methods: {
    home() {
        this.$router.push({ name: "Gestionale"})
    },
    addAccount() {
        this.utenti.push({nome:'',password:'',permessi:[]})
    },

    displayPermessi() {
        this.axios.post(this.store.path+'displayPermessi',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
           if(response.data.messaggio){
                  response.data.messaggio.forEach(element => {
                  this.permessi.push({value:element._id,label:element.label});
            });
            }else{console.log('Non ci sono permessi da mostrare')}

        })
    },
    getusers() {
        this.axios.post(this.store.path+'displayUsers',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
           if(response.data.messaggio){
                 response.data.messaggio.forEach(element => {
                  this.utenti.push({id:element.id,nome:element.nome, password:element.password,permessi:element.permessi})
            });
            }else{console.log('Non ci sono permessi da mostrare')}

        })
    },
    action(ind,user,nome,pw,permessi,save) {
        var  path = '';
        if(!save) {
            path='deleteCredential' ;
            this.utenti.splice(ind,1)

        }else {
            path = 'login'
            //this.utenti.push({nome:nome,password:pw,permessi:permessi});

        }
        this.axios.post(this.store.path+path,{nome:nome,password:pw,permessi:permessi,admin:true,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
           if(response.data.messaggio){
               console.log(response.data.messaggio)
            }else{console.log('Operazione non riuscita')}

        })
    },
  },
  
  beforeMount() {
      this.displayPermessi();
      this.getusers();
  },
  
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>
.m-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 10px;
    height: 100vh;
}
.con-sal {
    display: flex;
    flex-direction: column;
}
.nav-sale{
    flex-basis: 15vh;
}

.tab-cont {
    margin: auto;
    margin-top: 20px;
    background: #F5F5F5;
    overflow-y: scroll;
    flex-basis: 80%;
    width: 100vw;
}

#style-3::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar
{
  width: 6px;
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb
{
  background-color: #000000;
}
</style>